let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("iCRnm")).then(() => parcelRequire('792ZK'));